import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import {
  API_PATH_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION,
  TargetDeliveryTemplateAccessFunction,
} from './targetDeliveryTemplateAccessFunction.types';
import { ServerResponse, WithAuditDetails } from '../types';

const http = Http.getHttp();

export function getTargetDeliveryTemplateAccessFunctionList(
  deliveryFunctionId: string,
): AxiosPromise<ServerResponse<TargetDeliveryTemplateAccessFunction>> {
  return http.get(`${API_PATH_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION}`);
}

export function getTargetDeliveryTemplateAccessFunction(
  deliveryFunctionId: string,
  id: string
): AxiosPromise<ServerResponse<TargetDeliveryTemplateAccessFunction>> {
  return http.get(`${API_PATH_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION}/${id}`);
}

export function createTargetDeliveryTemplateAccessFunction(
  deliveryFunctionId: string,
  body: WithAuditDetails<TargetDeliveryTemplateAccessFunction>,
): AxiosPromise<ServerResponse<TargetDeliveryTemplateAccessFunction>> {
  return http.post(`${API_PATH_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION}`, body);
}

export function updateTargetDeliveryTemplateAccessFunction(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<TargetDeliveryTemplateAccessFunction>,
): AxiosPromise<ServerResponse<TargetDeliveryTemplateAccessFunction>> {
  return http.put(`${API_PATH_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION}/${id}`, body);
}

export function deleteTargetDeliveryTemplateAccessFunction(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<void>,
): AxiosPromise<ServerResponse<TargetDeliveryTemplateAccessFunction>> {
  return http.delete(`${API_PATH_TARGET_DELIVERY_TEMPLATE_ACCESS_FUNCTION}/${id}`, { data: body.auditDetails });
}
